<template>
  <div class="policyInformation">
    <el-row>
      <!-- 面包屑 -->
      <el-col :span="24"
        ><Breadcrumbs :arr="['碳汇管理平台', '碳标签']"
      /></el-col>
      <!-- 查询表单 -->
      <el-col class="search" :span="24">
        <el-form :inline="true" :model="search" class="demo-form-inline">
          <el-form-item label="标题">
            <el-input
              size="small"
              v-model="search.title"
              maxlength="100"
              clearable
              placeholder="请输入"
              class="inline-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司名称">
            <el-input
              size="small"
              v-model="search.companyName"
              maxlength="100"
              clearable
              placeholder="请输入"
              class="inline-input"
            ></el-input>
          </el-form-item>

          <el-form-item class="btn">

            <el-button size="small" type="primary" @click="getList" round
              >查询</el-button
            >
            <el-button
              size="small"
              style="margin: 0 0 0 50px"
              @click="reset"
              round
              type="info"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 表格数据 -->
      <el-col class="main_table" :span="24">
        <div class="table_btn">
          <!-- class="theme-btn" -->
          <el-button size="small" type="primary" @click="isAddData" round
            >新增碳标签</el-button>
        </div>
        <Tables
          class="table"
          :columns="columns"
          :loading="loading"
          :tableData="tableData"
        >
 
          <template #logo="scope">
            <div @click="downloadFile(scope.row.logo)" style="cursor: pointer;">
              <img style="height: 30px;" :src="scope.row.logo">
            </div>
          </template>
          <template #attachment="scope">
            <a class="color pointer" :href="scope.row.attachment" target="_blank">
              <img style="height: 30px;" :src="scope.row.attachment">
              </a>
          </template>
          <template #actions="scope">
            <div class="flex">
              <el-button type="text" @click="isEdit(scope.row)"
                >修改</el-button
              >
              <el-button type="text" @click="isDelete(scope.row.id)"
                >删除</el-button
              >
              <el-button type="text" @click="isView(scope.row)"
                >详情</el-button
              >
            </div>
          </template>
        </Tables>
        <Paginations :pageData="pageData" :sizeChange="sizeChange" :currentChange="currentChange" />
      </el-col>
    </el-row>
    <modaDialogl
      :dialog="dialog"
      :formData="formData"
      :handleClose="handleClose"
      :isView="isShowView"
    />
  </div>
</template>
<script>
import {
  getCarbonlabelList,
  delCarbonlabel,
} from "@/api/api";
import Breadcrumbs from "@/components/breadcrumbs/breadcrumbs.vue";
import Tables from "@/components/tables/tables.vue";
import modaDialogl from "./components/modaDialogl.vue";
import Paginations from "@/components/paginations/paginations.vue";
import { columns } from "./js/columns";
export default {
  name: "policyInformation",
  data() {
    return {
      search: {
        companyName: "",
        title: "",
      },
      // 表格展示数据
      tableData: [],
      // 表格显示标题
      columns: [],
      loading: false,
      // 弹出框设置
      dialog: {
        size: 720,
        visible: false,
        title: "新增",
      },
      // 分页
      pageData: {
        size: 10,
        page: 1,
        total: 0,
      },
      // 是否显示操作按钮
      isShowView: true,
      // 表单信息
      formData: {},
     
    };
  },
  methods: {
    // 页面初始化
    init() {
      this.columns = columns;
      this.getList();
    },
    // 获取数据列表
    getList() {
      let page = {
        current: this.pageData.page,
        size: this.pageData.size,
      };
      this.loading = true
      getCarbonlabelList(this.search, page).then((res) => {
        if (res.data.code == "200") {
          console.log(res.data,'ddd')
          this.tableData = res.data.data.records;
          this.pageData.total = res.data.data.total;
        }
        this.loading = false
      });
    },
    // 点击重置
    reset() {
      this.search = {
        companyName: "",
        title: "",
      };
      this.getList();
    },
    // 关闭弹出框
    handleClose() {
      this.dialog.visible = false;
    },
    // 新增
    isAddData() {
      this.formData = {
        title: "", // 主题
        logo: "", // logo
        companyName:"",//公司名称
        productName:"",//产品名称
        content:''//碳标签
      };
      this.dialog.visible = true;
      this.isShowView = true;
      this.dialog.title = "新增";
    },
    // 修改
    async isEdit(form) {
      this.formData = {...form};
      this.dialog.visible = true;
      this.dialog.title = "修改";
      this.isShowView = true;
    },
    // 详情
    async isView(form) {
        this.formData = {...form};
        this.dialog.visible = true;
        this.dialog.title = "详情";
        this.isShowView = false;
      
    },
    // 删除
    isDelete(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delCarbonlabel(id).then((res) => {
            if (res.data.code == 200) {
              if (this.tableData.length == 1) {
                let page = this.pageData.page - 1;
                page = page <= 0 ? 0 : page;
                this.pageData.page = page;
              }
              this.getList();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 切换条数
    sizeChange(val){
        this.pageData.size = val
        this.getList()
    },
    // 切换页数
    currentChange(val){
        this.pageData.page = val
        this.getList()
    },
    setUrl(arr){
      arr = JSON.parse(arr)
      if(arr.length)
        return arr[0].url
      else return ''
    },
    downloadFile(fileBase64) {
      // 将Base64编码转换为Blob对象
      const byteCharacters = atob(fileBase64.split(',')[1]);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/octet-stream' });

      // 创建下载链接
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = '图片.png';
      a.click();

      // 释放URL对象
      window.URL.revokeObjectURL(url);
    }
  },
  mounted() {
    this.init();
  },
  components: {
    Breadcrumbs,
    Tables,
    modaDialogl,
    Paginations,
  },
};
</script>
<style scoped>

.flex {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.operation{
  color: #409EFF;
}
</style>
